import React, { useState, useEffect } from "react";
import { Button, Typography, Chip } from "@mui/material";
import FormDialog from "./FormDialog";
import moment from "moment-business-days";
import axios from "axios";
import { use } from "react";

const LeaveRequestForm = ({
  open,
  setOpen,
  selectedValue,
  categories,
  // lineManagers: initialLineManagers,
  info,
  onSuccess,
  socket,
  myLineManager,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [value, setValue] = useState({});
  const [fields, setFields] = useState([]);
  const [holidays, setHolidays] = useState([]);
  // const [lineManagers, setLineManagers] = useState(initialLineManagers || []);

  // Fetch line managers from the backend
  // useEffect(() => {
  //   const fetchLineManagers = async () => {
  //     try {
  //       const response = await axios.get("/api/role/my-line-managers/");
  //       const managersList = response.data.data.map((manager) => ({
  //         label: manager.names,
  //         value: manager.id,
  //       }));
  //       setLineManagers(managersList);
  //     } catch (error) {}
  //   };

  //   if (open) {
  //     fetchLineManagers();
  //   }
  // }, [open]);

  useEffect(() => {
    // console.log("line managers-----", myLineManager);
  }, [myLineManager]);

  useEffect(() => {
    const fetchInfo = async () => {
      if (open && info?.resource?.id) {
        try {
          const response = await axios.get("/api/request/requests/info");
          if (response.data) {
            if (typeof info.setInfo === "function") {
              info.setInfo(response.data);
            }
          }
        } catch (error) { }
      }
    };
    fetchInfo();
  }, [open]);

  const handleSuccess = () => {
    if (typeof onSuccess === "function") onSuccess();

    if (typeof info.setInfo === "function") {
      axios.get("/api/request/requests/info").then((response) => {
        info.setInfo(response.data);
      });
    }
    if (socket && value?.lineManager) {
      socket.emit("sendNotification", {
        message: `You have a new permission request from ${info.resource.names}`,
        resourceId: info.resource.id,
        receiverId: value?.lineManager,
        type: "permission_request",
        projectId: info.resource.id,
      });
    }
  };

  // useEffect(() => {
  //   if (open && lineManagers.length > 0) {
  //     setValue((prev) => ({
  //       ...prev,
  //       lineManager: lineManagers[0]?.value,
  //     }));
  //   }
  // }, [open, lineManagers]);

  let leaveDays = selectedValue?.leaveDays;

  const setValue0 = (name, val) => {
    if (!name) return null;
    setValue((v) => ({ ...v, [name]: val }));
  };

  useEffect(() => {
    const fetchHolidays = async () => {
      try {
        const response = await axios.get("/api/holidays");
        const holidayDates = response.data.data.map((holiday) =>
          moment(`2000-${holiday.date}`, "YYYY-MM-DD").format("MM-DD")
        ); // Normalize holidays to "MM-DD"
        setHolidays(holidayDates);
      } catch (error) {
        console.error("Error fetching holidays:", error);
      }
    };

    if (open) {
      fetchHolidays();
    }
  }, [open]);

  const createDateMapFunction = (dateObject) => {
    const isWeekend =
      dateObject.date.weekDay.index === 0 ||
      dateObject.date.weekDay.index === 6;
    const isHoliday = holidays.includes(
      `${dateObject.date.month.number
        .toString()
        .padStart(2, "0")}-${dateObject.date.day.toString().padStart(2, "0")}`
    );
    const isPastDate = moment(dateObject.date.toDate()).isBefore(
      moment(),
      "day"
    );

    return {
      disabled: isWeekend || isPastDate || isHoliday,
      className: isHoliday ? "holiday-date" : isWeekend ? "weekend-date" : "",
      style: isHoliday ? { color: "red" } : isWeekend ? { color: "#ccc" } : {},
      title: isHoliday ? "Public Holiday" : isWeekend ? "Weekend" : "",
    };
  };

  const calculateLeaveDays = (startDate, endDate, startTime, endTime) => {
    if (!startDate || !endDate) return 0;

    const start = moment(startDate);
    const end = moment(endDate);

    if (start.format('YYYY-MM-DD') === end.format('YYYY-MM-DD')) {
      if (startTime && endTime) {
        const startDT = moment(`${start.format('YYYY-MM-DD')} ${startTime}`);
        const endDT = moment(`${end.format('YYYY-MM-DD')} ${endTime}`);
        const hrs = endDT.diff(startDT, 'hours', true);
        return Math.round(hrs * 100) / 100;
      }
      return 1;
    }

    let dayCount = 0;
    let currentDate = start.clone();

    while (currentDate.isSameOrBefore(end, 'day')) {
      if (!holidays.includes(currentDate.format("MM-DD"))) {
        dayCount++;
      }
      currentDate.add(1, "days");
    }

    return dayCount;
  };

  const defaultFields = [
    {
      name: "startDate",
      type: "date",
      value: value["startDate"],
      weekendDisabled: true,
      holidaysDisabled: true,
      label: "Start Date",
      disabled: !leaveDays, // Disable if no days available
      required: true,
      setValue: (val) => setValue0("startDate", val),
      validate: (date) => {
        const formattedDate = moment(date).format("MM-DD");
        // Holiday validation
        if (holidays.includes(formattedDate)) {
          return "Selected date is a holiday.";
        }
        return true;
      },
      mapDays: createDateMapFunction, // Pass the date mapping function
    },
    {
      name: "categoryId",
      type: "date",
      value: selectedValue?.id,
      label: "Category",
      hidden: true,
    },
    {
      name: "endDate",
      type: "date",
      label: "Return Date",
      weekendDisabled: false,
      holidaysDisabled: true,
      value: value["endDate"],
      maxDate: value["startDate"]
        ? selectedValue?.type === "maternity"
          ? moment(value["startDate"]).add(90, "days")
          : (() => {
              let maxDate = moment(value["startDate"]);
              let daysToAdd = (leaveDays || 0) - 1;
              let added = 0;
              while (added < daysToAdd) {
                maxDate.add(1, 'day');
                if (!holidays.includes(maxDate.format("MM-DD"))) {
                  added++;
                }
              }
              return maxDate;
            })()
        : null,
      minDate: value["startDate"]
        ? moment(value["startDate"])
        : null,
      required: true,
      disabled: !value["startDate"] || !leaveDays,
      setValue: (val) => setValue0("endDate", val),
      validate: (date) => {
        if (holidays.includes(moment(date).format("MM-DD"))) {
          return "Selected date is a holiday.";
        }
        return true;
      },
      mapDays: createDateMapFunction,
    },
    {
      name: "startTime",
      type: "time",
      label: "Start Time (for same-day requests)",
      value: value["startTime"],
      required: false,
      hidden:
        !value["startDate"] ||
        !value["endDate"] ||
        moment(value["startDate"]).format("YYYY-MM-DD") !==
          moment(value["endDate"]).format("YYYY-MM-DD"),
      setValue: (val) => setValue0("startTime", val),
    },
    {
      name: "endTime",
      type: "time",
      label: "End Time (for same-day requests)",
      value: value["endTime"],
      required: false,
      hidden:
        !value["startDate"] ||
        !value["endDate"] ||
        moment(value["startDate"]).format("YYYY-MM-DD") !==
          moment(value["endDate"]).format("YYYY-MM-DD"),
      setValue: (val) => setValue0("endTime", val),
      validate: (time) => {
        if (value["startTime"] && time) {
          const startDT = moment(
            `${moment(value["startDate"]).format("YYYY-MM-DD")} ${value["startTime"]}`
          );
          const endDT = moment(
            `${moment(value["endDate"]).format("YYYY-MM-DD")} ${time}`
          );
          if (endDT.isSameOrBefore(startDT)) {
            return "End time must be after start time.";
          }
        }
        return true;
      },
    },
    {
      name: "leaveDays",
      type: "number",
      label: "Requested Days/Hours",
      disabled: true,
      required: false,
      value:
        value["startDate"] && value["endDate"]
          ? calculateLeaveDays(value["startDate"], value["endDate"], value["startTime"], value["endTime"])
          : null,
    },

    {
      name: "maxDays",
      type: "number",
      label: "Max Leave Days",
      disabled: true,
      hidden: false, // Always show max days
      value: leaveDays || 0,
    },
    {
      name: "supportDocument",
      type: "file-drag",
      label: "Support Document",
      value: value["supportDocument"],
      required: false,
      setValue: (val) => setValue0("supportDocument", val),
    },
  ];

  const extraFields = [
    {
      name: "location",
      type: "text",
      label: "Location",
      value: value["location"],
      required: false,
      setValue: (val) => setValue0("location", val),
    },
    // {
    //   name: "lineManager",
    //   type: "select",
    //   label: "Line Manager",
    //   value: value["lineManager"],
    //   values: myLineManager
    //     ? [{
    //         label: myLineManager.names,
    //         value: myLineManager.id,
    //       }]
    //     : [],
    //   required: true,
    //   setValue: (val) => setValue0("lineManager", val),
    // },

    {
      name: "lineManager",
      type: "select",
      label: "Line Manager",
      value: value["lineManager"],
      values: Array.isArray(myLineManager) && myLineManager.length > 0
        ? myLineManager.map(lm => ({
          label: lm.names,
          value: lm.id,
        }))
        : [],
      required: true,
      setValue: (val) => setValue0("lineManager", val),
    },

    {
      name: "description",
      type: "textarea",
      label: "Description",
      value: value["description"],
      required: false,
      setValue: (val) => setValue0("description", val),
    },
  ];

  const studyFields = [
    {
      name: "country",
      type: "text",
      label: "Country Name",
      value: value["country"],
      required: false,
      setValue: (val) => setValue0("country", val),
    },
    {
      name: "schoolName",
      type: "text",
      label: "School Name",
      value: value["schoolName"],
      required: true,
      setValue: (val) => setValue0("schoolName", val),
    },
    {
      name: "educationLevel",
      type: "text",
      label: "Education Level",
      value: value["educationLevel"],
      required: true,
      setValue: (val) => setValue0("educationLevel", val),
    },
    {
      name: "course",
      type: "text",
      label: "Course to be Attended",
      value: value["course"],
      required: true,
      setValue: (val) => setValue0("course", val),
    },
  ];

  const sickFields = [
    {
      name: "hospitalName",
      type: "text",
      label: "Hospital Name",
      value: value["hospitalName"],
      required: true,
      setValue: (val) => setValue0("hospitalName", val),
    },
  ];

  const buildFields = () => {
    if (selectedValue) {
      let allFields = defaultFields;

      if (selectedValue.type === "study") {
        allFields = [...allFields, ...studyFields, ...extraFields];
      } else if (selectedValue.type === "sick") {
        const supportDocumentField = allFields.find(
          (f) => f.name === "supportDocument"
        );
        // Remove supportDocument from defaultFields
        allFields = allFields.filter((f) => f.name !== "supportDocument");

        // Remove location from extraFields
        const filteredExtraFields = extraFields.filter(
          (f) => f.name !== "location"
        );

        // Extract lineManager and description
        const lineManagerField = filteredExtraFields.find(
          (f) => f.name === "lineManager"
        );
        const descriptionField = filteredExtraFields.find(
          (f) => f.name === "description"
        );

        allFields = [
          ...allFields,
          ...sickFields,

          supportDocumentField,
          descriptionField,
          lineManagerField,
        ];
      } else {
        allFields = [...allFields, ...extraFields];
      }

      setFields(allFields);
    } else {
      setFields([]);
    }
  };

  const handleSubmit = async () => {
    const payload = {
      categoryId: selectedValue?.id,
      startDate: value.startDate,
      endDate: value.endDate,
      leaveDays: calculateLeaveDays(value.startDate, value.endDate),
      lineManager: value.lineManager,
      description: value.description,
      supportDocument: value.supportDocument,
    };

    try {
      const response = await axios.post("/api/request/create", payload);
      if (response.status === 200) {
        onSuccess();
      } else {
        console.error("Error submitting leave request:", response.data.message);
      }
    } catch (error) {
      console.error("Error submitting leave request:", error.message);
    }
  };

  useEffect(buildFields, [selectedValue, value, holidays]);

  return (
    <FormDialog
      onSuccess={handleSuccess}
      url="/api/request/create"
      formAlert={
        selectedValue?.message && (
          <div dangerouslySetInnerHTML={{ __html: selectedValue?.message }} />
        )
      }
      maxWidth="md"
      col={6}
      title="Submit New Permission Request"
      open={open}
      setOpen={setOpen}
      fields={fields}
    />
  );
};

export default LeaveRequestForm;
